import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../services/i18nService';

import styles from '../../testOverview.scss';

const MicDeviceHealthCheckStatus = ({ shouldShowMicHealthInformation, shouldShowMicHealthStatus, shouldShowMicHealthCheckInProgress }) => (
    shouldShowMicHealthInformation && (<div className={`micDeviceHealthCheckStatus ${styles.micDeviceHealthCheckStatus}`}>
        <span className={styles.hardwareSelectorLabel}>
            {t('hardwareAccessCheck.microphone')}
        </span>
        {shouldShowMicHealthStatus && (
            shouldShowMicHealthCheckInProgress ? (
                <span className={`checking ${styles.Checking}`}>{t('hardwareAccessCheck.checking')}</span>
            ) : (
                <span className={`checkedMessage ${styles.CheckedMessage}`}>
                    <i className={`fa fa-check-circle ${styles.CheckCircleIcon}`} aria-hidden="true" />{' '}
                    {t('hardwareAccessCheck.checked')}
                </span>
            )
        )}
    </div>)
);

MicDeviceHealthCheckStatus.propTypes = {
    shouldShowMicHealthInformation: PropTypes.bool,
    shouldShowMicHealthStatus: PropTypes.bool,
    shouldShowMicHealthCheckInProgress: PropTypes.bool.isRequired,
};

MicDeviceHealthCheckStatus.defaultProps = {
    shouldShowMicHealthInformation: true,
    shouldShowMicHealthStatus: true,
};

export default MicDeviceHealthCheckStatus;
